import React, { useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import { TopNavigationMenu } from "./Header/TopNavigationMenu";
import { redirectToAppNewsepickPage } from "../../utils/Common";

function MyAccountPanel(props) {

    const closeMyAccountPanel = () => {
        document.body.classList.remove('activeMyAccountPanelProf');
    };

    useEffect(() => {
        
    }, [])

    return (
        <div className="myAccountPanel unauth">
            <span className="myAccountPanelOverlay" onClick={() => { closeMyAccountPanel(); }}></span>
            <div className="myAccountPanelSlide">
                <button className="closebtn" onClick={() => { closeMyAccountPanel(); }}>
                    <i className="fa-solid fa-angle-right" />
                </button>
                
                <div className="myAccountPanelSlideInn">
                    <div className="myAccUserInfo">                        
                        <ul>
                            <li><a href={"javascript:void(0)"} onClick={() => redirectToAppNewsepickPage("login")}>Sign In</a></li>
                            <li><a href={"javascript:void(0)"} onClick={() => redirectToAppNewsepickPage("individual/signup")}>Sign Up</a></li>
                        </ul>                        
                    </div>

                    <div className="d-lg-none">
                        <TopNavigationMenu />
                    </div>

                    <ul className="myAccountPanelNav">
                        {/* <li><Link to={"/"} onClick={() => { closeMyAccountPanel(); }}><i className="iNotification_Stroke" /> Notifications</Link></li> */}
                        {/* <li><Link to={"/"} onClick={() => { redirectToAppNewsepickPage("saved-items"); closeMyAccountPanel(); }}><i className="iSaved-Item_Stroke" /> Saved Items</Link></li> */}
                        <ul className="small-menu">                            
                            {/* <li><Link to={"/"} onClick={() => { closeMyAccountPanel(); }}>Feedback</Link></li> */}
                            <li><NavLink to={"/terms-condition"} exact activeClassName="active" onClick={() => { closeMyAccountPanel(); }}>Terms & Conditions</NavLink></li>
                            <li><NavLink to={"/privacy-policy"} exact activeClassName="active" onClick={() => { closeMyAccountPanel(); }}>Privacy Policy</NavLink></li>
                        </ul>
                    </ul>
                </div>
            </div>
        </div>
    );
}

export { MyAccountPanel };
